var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportAddTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 12.7997V10.6663H21.334V12.7997M16.0007 10.6663V21.333M16.0007 21.333H13.8673M16.0007 21.333H18.134M8.00065 26.6663H24.0007C25.4734 26.6663 26.6673 25.4724 26.6673 23.9997V7.99967C26.6673 6.52692 25.4734 5.33301 24.0007 5.33301H8.00065C6.52789 5.33301 5.33398 6.52692 5.33398 7.99967V23.9997C5.33398 25.4724 6.52789 26.6663 8.00065 26.6663Z",
    stroke: "white",
    strokeOpacity: 0.61,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAddTextIcon);
export default __webpack_public_path__ + "static/media/report-add-text-icon.7fe357875c5fb56ea8033b9c3b753d1f.svg";
export { ForwardRef as ReactComponent };